export default __webpack_public_path__ + "static/media/setting-grey-icon.4df72a40.svg";